export default __webpack_public_path__ + "static/media/AU.51a45afa.png";